// IE 2026 10 22 / ODOO-5800 (Igor 22.10: «У меня уже есть компонент AttrChart. Я ожидал, что все графики в форме ячейки и в других построены на одном этом компоненте.
// Разница только в настройках его … переделай на него»): ГРАФИКИ ВЕРСІЇ И ПЛАНИ ФОРМЫ ЯЧЕЙКИ — НА ПЛАТФОРМЕННОМ AttrChart через синтетический виджет (образец —
// utils/cellChart.js блока запасов): store.WIDGETS[wid] с одним AttrChart над doc.rows (freq M), серии = attr.attrs. Здесь — адаптеры ответа бэка в настройки чарта:
//   versionsChart_build(cell_passport.versions) — версии линиями (толщина / цвет по rank, своя строка пунктиром), факт столбиками, стек оперативного плана по статусам
//     (Column + Stacked чарта; штриховка hatch_base), ТЕКУЩАЯ версия — столбиками РЯДОМ с фактом (chart_stack2 'beside' + chart_down у серии, ODOO-4646);
//   plansChart_build(cell_passport.plan) — факт / согласованный столбиками (месяцы не пересекаются — штатный стек), уровни линиями по стилю серии бэка; правило нулей —
//     пропуск внутри серии рисуется как 0 (данными).
// Общее: месяц ячейки — полоса drawAlarmZone rows 'all', месяцы факта планов — полоса; ось месяцев / лет — 'axisX-mainRow' (+ keep = месяц ячейки); явный потолок главной
// оси 'axisY-max' / 'axisY-min' чарта (стек wijmo складывал бы факт и текущую версию); легенды wijmo нет ('legend-position' None) — форма легенды CellLegendPop
// (components/widgets/CellSeriesChart.vue), фокус серии — AttrChart.onLegendSeriesHover, подсказка — wijmo (tooltip-inline; при открытой легенде — inlineTipOff).
// Чистые функции — юнит tests/unit/cellSeriesChart.test.mjs. Прежние модули cellVersionsChart.js / cellPlanChart.js (свой SVG) сняты.
import { t as t0 } from '@/i18n'

export const SERIES_CHART_HEIGHT = 230
export const WIDTH_MAX = 3.5, WIDTH_MIN = 1
export const PALETTE = ['#1e88e5', '#8e24aa', '#f09832', '#43a047', '#e53935', '#00897b', '#6d4c41', '#546e7a']
export const FACT_COLOR = '#546e7a', FACT_OPACITY = 0.3
export const CUR_COLOR = '#1e88e5', CUR_OPACITY = 0.55
export const RULE_TEXT = 'Bars — fact and the current version; lines — other versions'
export const ZERO_RULE_TEXT = 'A month without a plan between the plan months of a series is shown as 0'
export const OPER_STACK = ['done', 'confirmed', 'draft', 'autoplan', 'uncovered']
export const OPER_STYLE = {   // токены графика DETAILS · MOVEMENTS (cellChart.js): done = факт, confirmed = IN, uncovered / expiring — штриховка
    done:      { title: 'Done',         color: FACT_COLOR, fill: FACT_COLOR, opacity: FACT_OPACITY, hatch: false },
    confirmed: { title: 'Confirmed',    color: '#4caf50',  fill: '#99cc99',  opacity: 0.8,          hatch: false },
    draft:     { title: 'Draft',        color: '#f2b600',  fill: '#f2b600',  opacity: 0.45,         hatch: false },
    autoplan:  { title: 'Auto-planned', color: '#fb8c00',  fill: '#fb8c00',  opacity: 0.7,          hatch: false },
    uncovered: { title: 'Uncovered',    color: '#e53935',  fill: '#e53935',  opacity: 0.3,          hatch: true },
    expiring:  { title: 'Expiring',     color: '#8e24aa',  fill: '#ce93d8',  opacity: 0.8,          hatch: true },
    normal:    { title: 'Normal stock', color: '#90a4ae',  fill: '#90a4ae',  opacity: 0.35,         hatch: false },
}
const OPER_TONE = { red: OPER_STYLE.uncovered, orange: OPER_STYLE.autoplan, yellow: OPER_STYLE.draft, green: OPER_STYLE.confirmed, grey: OPER_STYLE.done, gray: OPER_STYLE.done, purple: OPER_STYLE.expiring, violet: OPER_STYLE.expiring }
const OPER_UNKNOWN = { title: '', color: '#9e9e9e', fill: '#9e9e9e', opacity: 0.5, hatch: false }
const _t = (s, p) => String(s || '').replace(/\{(\w+)\}/g, (m, k) => (p && k in p) ? String(p[k]) : m)

// ---- форматы (были в cellVersionsChart.js; используются паспортом планов и сводками) ----
export function seriesChart_fmtNum(v) {
    if (v === null || v === undefined || !Number.isFinite(Number(v))) return ''
    const n = Number(v)
    return (Math.abs(n) >= 1000 ? Math.round(n) : Math.round(n * 10) / 10).toLocaleString('en-US').replace(/,/g, ' ')
}
export function seriesChart_fmtPct(p) {
    if (p === null || p === undefined || p === '' || !Number.isFinite(Number(p))) return '—'
    const a = Math.round(Math.abs(Number(p)) * 10) / 10, v = Number(p) < 0 ? -a : a
    return (v < 0 ? '−' : (v > 0 ? '+' : '')) + String(Math.abs(v)).replace(/\.0$/, '') + ' %'
}
export function seriesChart_fmtDate(d) {
    const s = String(d || '').slice(0, 10)
    return /^\d{4}-\d{2}-\d{2}$/.test(s) ? s.slice(8, 10) + '.' + s.slice(5, 7) + '.' + s.slice(0, 4) : s
}
export function seriesChart_window(from, to) {
    const f = String(from || '').slice(0, 10), tt = String(to || '').slice(0, 10)
    if (f && tt) return f.slice(0, 4) === tt.slice(0, 4) ? f.slice(8, 10) + '.' + f.slice(5, 7) + '–' + seriesChart_fmtDate(tt) : seriesChart_fmtDate(f) + '–' + seriesChart_fmtDate(tt)
    return f ? 'from ' + seriesChart_fmtDate(f) : ''
}
export function versionsChart_deviationText(dev, t = _t) {
    if (!dev || typeof dev !== 'object') return ''
    const win = seriesChart_window(dev.date_from, dev.date_to)
    const src = ((dev.title || dev.vs || '') + (win ? ' (' + win + ')' : '')).trim()
    const parts = [t('Deviation from current: {pct}', { pct: seriesChart_fmtPct(dev.pct) })]
    if (src) parts.push(t('source: {src}', { src }))
    return parts.join(' · ')
}
export function seriesChart_niceStep(max, ticks = 4) {
    const m = Math.max(Number(max) || 0, 1e-9)
    const raw = m / ticks, p = Math.pow(10, Math.floor(Math.log10(raw))), r = raw / p
    return (r <= 1 ? 1 : r <= 2 ? 2 : r <= 2.5 ? 2.5 : r <= 5 ? 5 : 10) * p
}
export function seriesChart_months(a, b) {
    const out = []
    let y = +String(a).slice(0, 4), m = +String(a).slice(5, 7)
    const ye = +String(b).slice(0, 4), me = +String(b).slice(5, 7)
    if (![y, m, ye, me].every(Number.isFinite)) return out
    while (y < ye || (y === ye && m <= me)) { out.push(y + '-' + String(m).padStart(2, '0')); m += 1; if (m > 12) { m = 1; y += 1 } }
    return out
}
export function seriesChart_rgba(hex, opacity) {   // #rrggbb + прозрачность → #rrggbbaa (wijmo принимает 8-значный hex)
    const h = String(hex || '').trim()
    if (!/^#[0-9a-f]{6}$/i.test(h) || opacity === null || opacity === undefined || !Number.isFinite(Number(opacity)) || Number(opacity) >= 1) return h
    return h + Math.round(Math.max(0, Number(opacity)) * 255).toString(16).padStart(2, '0')
}
export function versionsChart_width(rank, n) {
    const r = Math.max(0, Number(rank) || 0), k = Math.max(1, (Number(n) || 1) - 1)
    return Math.round(Math.max(WIDTH_MIN, WIDTH_MAX - r * (WIDTH_MAX - WIDTH_MIN) / k) * 100) / 100
}
export function versionsChart_color(rank) {
    const r = Math.max(0, Number(rank) || 0)
    return { color: PALETTE[r % PALETTE.length], opacity: Math.max(0.4, Math.round((1 - r * 0.12) * 100) / 100) }
}
export function versionsChart_operOrder(keys, declared) {
    const d = Array.isArray(declared) ? declared.filter(k => keys.includes(k)) : []
    const rest = keys.filter(k => !d.includes(k))
    return d.concat(OPER_STACK.filter(k => rest.includes(k)), rest.filter(k => !OPER_STACK.includes(k)))
}
export function versionsChart_operStyle(status, hint) {
    const k = String(status || '').trim().toLowerCase(), h = String(hint || '').trim().toLowerCase()
    if (h) return OPER_STYLE[h] || OPER_TONE[h] || OPER_UNKNOWN
    return OPER_STYLE[k] || OPER_UNKNOWN
}

function _pts(src) {   // точки {date|ym, value|v} → [{ym, v, st}] по месяцам; пустые / NaN — вон
    const pts = Array.isArray(src && src.points) ? src.points : []
    return pts.filter(p => p && typeof p === 'object').map(p => ({ ym: String(p.ym != null ? p.ym : (p.date || '')).slice(0, 7), v: p.v !== undefined ? p.v : p.value, st: String(p.status || '').trim().toLowerCase() || 'confirmed' }))
        .filter(p => /^\d{4}-\d{2}$/.test(p.ym) && p.v !== null && p.v !== undefined && p.v !== '' && Number.isFinite(Number(p.v)))
        .map(p => ({ ym: p.ym, v: Number(p.v), st: p.st })).sort((a, b) => a.ym < b.ym ? -1 : a.ym > b.ym ? 1 : 0)
}
export function seriesChart_fillZeros(pts) {   // правило нулей: месяц без значения МЕЖДУ значимыми месяцами серии — 0 (zero: true)
    const src = Array.isArray(pts) ? pts.filter(p => p && typeof p.ym === 'string' && p.ym.length === 7 && Number.isFinite(Number(p.v))).sort((a, b) => a.ym < b.ym ? -1 : a.ym > b.ym ? 1 : 0) : []
    if (src.length < 2) return src.map(p => ({ ym: p.ym, v: Number(p.v) }))
    const have = Object.fromEntries(src.map(p => [p.ym, Number(p.v)]))
    return seriesChart_months(src[0].ym, src[src.length - 1].ym).map(ym => ym in have ? { ym, v: have[ym] } : { ym, v: 0, zero: true })
}
function _axisRange(max, min) {   // явные границы главной оси: «человеческий» шаг; wijmo иначе сложил бы стек факт + текущая версия
    const step = seriesChart_niceStep((max - min) || 1)
    return { max: Math.ceil((max || 1) / step) * step, min: min < 0 ? Math.floor(min / step) * step : 0 }
}
function _zoneBand(rows, ym, style) {   // полоса месяца через все ряды (как cellChart_zones: границы — середины между соседними месяцами)
    const n = rows.length, i = rows.findIndex(r => r.date.slice(0, 7) === ym)
    if (i < 0) return null
    const ms = rows.map(r => new Date(r.date).getTime()), iso = (v) => new Date(v).toISOString().slice(0, 10)
    return { xMin: i === 0 ? rows[0].date : iso((ms[i - 1] + ms[i]) / 2), xMax: i === n - 1 ? rows[n - 1].date : iso((ms[i] + ms[i + 1]) / 2), rows: 'all', cssClass: 'chart-zone-grey', style }
}
const CENTER_STYLE = 'fill: #7b1fa2; opacity: 0.08'
const FACT_STYLE = 'fill: #546e7a; opacity: 0.06'
function _lineAttr(binding, title, color, opacity, width, dash) {
    const c = seriesChart_rgba(color, opacity)
    const css = { fill: c, stroke: c, strokeWidth: width }
    if (dash) css.strokeDasharray = dash
    return { binding, title, attr_type: 'AttrNumber', chartType: 'LineSymbols', use: true, cssStyleChart: css, aggregate: 'Max', format: 'n0' }
}
function _barAttr(binding, title, fill, opacity, stroke) {
    return { binding, title, attr_type: 'AttrNumber', chartType: 'Column', use: true, cssStyleChart: { fill: seriesChart_rgba(fill, opacity), stroke: stroke || seriesChart_rgba(fill, opacity), strokeWidth: 0 }, aggregate: 'Max', format: 'n0' }
}
function _legendBar(fill, opacity) { return seriesChart_rgba(fill, Math.min(1, (Number(opacity) || 0.4) + 0.2)) }

// ---- ВЕРСІЇ: cell_passport.versions {measure, title, kind, month, series: [{version, title, date_from, kind, current, rank, own, points}], fact, oper, deviation, note} ----
export function versionsChart_visible(raw) {
    if (!raw || raw.state !== 'ok') return false
    const n = Array.isArray(raw.series) ? raw.series.filter(s => s && Array.isArray(s.points) && s.points.length).length : 0
    return n >= 1 || !!(raw.oper && typeof raw.oper === 'object' && Array.isArray(raw.oper.points) && raw.oper.points.length)
}
export function versionsChart_key(s) { return 'v_' + String(s.rank == null ? 0 : s.rank) + '_' + String(s.version || '').replace(/[^A-Za-z0-9_]/g, '_') }
export function versionsChart_build(raw, t = _t, opts = {}) {   // → настройки синтетического AttrChart; null — показывать нечего
    if (!versionsChart_visible(raw)) return null
    const series = (raw.series || []).filter(s => s && Array.isArray(s.points) && s.points.length).slice().sort((a, b) => (a.rank || 0) - (b.rank || 0))
    const n = series.length, center = String(raw.month || '').slice(0, 7)
    const fact = (raw.fact && typeof raw.fact === 'object' && Array.isArray(raw.fact.points)) ? raw.fact : null
    const oper = (raw.oper && typeof raw.oper === 'object' && Array.isArray(raw.oper.points)) ? raw.oper : null
    const factPts = _pts(fact), operPts = _pts(oper)
    let mFrom = center || '9999-99', mTo = center || '0000-00'
    const grow = (ym) => { if (ym < mFrom) mFrom = ym; if (ym > mTo) mTo = ym }
    for (const s of series) for (const p of _pts(s)) grow(p.ym)
    if (!n) for (const p of operPts.concat(factPts)) grow(p.ym)   // одни столбики — окно по ним
    const months = seriesChart_months(mFrom, mTo)
    const rows = months.map(ym => ({ date: ym + '-01' }))
    const byYm = Object.fromEntries(rows.map(r => [r.date.slice(0, 7), r]))
    let max = 0, min = 0
    const attrs = [], legend = [], hatch = {}
    // стек оперативного плана по статусам (Column + Stacked) либо столбики факта
    const statuses = []
    if (oper) {
        const declared = (Array.isArray(oper.statuses) ? oper.statuses : []).filter(s => s && typeof s === 'object' && s.status).map(s => ({ ...s, status: String(s.status).trim().toLowerCase() }))
        const seen = []; for (const p of operPts) if (!seen.includes(p.st)) seen.push(p.st)
        const keys = versionsChart_operOrder([...new Set(declared.map(s => s.status).concat(seen))], declared.map(s => s.status))
        const sums = {}
        for (const k of keys) {
            const d = declared.find(s => s.status === k) || {}, st = versionsChart_operStyle(k, d.color_hint)
            const binding = 'oper_' + k.replace(/[^A-Za-z0-9_]/g, '_')
            const title = d.title || (st.title ? t(st.title) : k)
            statuses.push({ status: k, binding, title, color: st.color, fill: st.fill, opacity: st.opacity, hatch: st.hatch })
            for (const p of operPts) if (p.st === k && byYm[p.ym] && p.v) { byYm[p.ym][binding] = (byYm[p.ym][binding] || 0) + p.v; const sm = sums[p.ym] || (sums[p.ym] = { pos: 0, neg: 0 }); if (p.v > 0) sm.pos += p.v; else sm.neg += p.v }
            const a = _barAttr(binding, title, st.fill, st.opacity, st.color)
            if (st.hatch) { a.hatch_base = binding; a.hatch_color = st.color; hatch[binding] = st.color }
            attrs.push(a)
            legend.push({ kind: binding, title, color: _legendBar(st.fill, st.opacity), hatch: st.hatch ? st.color : '', bar: true, group: 'oper', sub: '' })
        }
        for (const sm of Object.values(sums)) { if (sm.pos > max) max = sm.pos; if (sm.neg < min) min = sm.neg }
    } else if (fact) {
        for (const p of factPts) if (byYm[p.ym]) { byYm[p.ym].fact = p.v; if (p.v > max) max = p.v; if (p.v < min) min = p.v }
        attrs.push(_barAttr('fact', t('Fact · {title}', { title: fact.title || fact.measure || '' }), FACT_COLOR, FACT_OPACITY))
        legend.push({ kind: 'fact', title: t('Fact · {title}', { title: fact.title || fact.measure || '' }), color: _legendBar(FACT_COLOR, FACT_OPACITY), bar: true, group: 'fact', sub: '' })
    }
    const hasBars = attrs.length > 0
    // версии: текущая — столбиками рядом (beside), прочие — линиями по rank (тоньше и бледнее)
    const lines = []
    let cur = null
    for (const s of series) {
        const key = versionsChart_key(s), pts = _pts(s), c = versionsChart_color(s.rank), width = versionsChart_width(s.rank, n)
        for (const p of pts) if (byYm[p.ym]) { byYm[p.ym][key] = p.v; if (p.v > max) max = p.v; if (p.v < min) min = p.v }
        const since = seriesChart_fmtDate(s.date_from)
        if (s.current && !cur) {
            cur = { kind: key, title: s.title, color: _legendBar(CUR_COLOR, CUR_OPACITY), bar: true, current: true, own: !!s.own, sub: since, group: 'version', rank: s.rank }
            const a = _barAttr(key, s.title, CUR_COLOR, CUR_OPACITY)
            if (hasBars) a.chart_down = true   // ODOO-4646 'beside': своей колонкой рядом с фактом / стеком, значения не зеркалятся
            attrs.push(a); legend.push(cur)
        } else {
            const dash = s.own && !s.current ? '6 3' : ''
            lines.push({ z: n - (s.rank || 0), attr: _lineAttr(key, s.title, c.color, c.opacity, width, dash) })
            legend.push({ kind: key, title: s.title, color: seriesChart_rgba(c.color, c.opacity), bar: false, width, dash, current: false, own: !!s.own, sub: since, group: 'version', rank: s.rank })
        }
    }
    for (const l of lines.sort((a, b) => a.z - b.z)) attrs.push(l.attr)   // текущая по rank — поверх (последней)
    const range = _axisRange(max, min)
    const zones = []
    const cz = _zoneBand(rows, center, CENTER_STYLE); if (cz) zones.push(cz)
    const curRow = byYm[center] || {}
    const curLg = legend.find(l => l.current) || legend.find(l => l.group === 'version')
    const sum = [n || !oper ? t('Versions: {n}', { n }) : (oper.title || oper.measure || t('Operational plan'))]
    if (curLg) sum.push((curRow[curLg.kind] != null ? seriesChart_fmtNum(curRow[curLg.kind]) + ' · ' : '') + curLg.title)
    if (raw.deviation && raw.deviation.pct !== null && raw.deviation.pct !== undefined) sum.push(seriesChart_fmtPct(raw.deviation.pct))
    const chart = { 'axisY-max': range.max, 'axisY-min': range.min, 'axisX-mainRow-keep': center }
    if (hasBars && cur) chart.chart_stack2 = 'beside'
    return { rows, attrs, zones, legend, chart, center, n, measure: raw.measure, hatch, statuses,
             summary: sum.join(' · '), deviation: versionsChart_deviationText(raw.deviation, t), note: raw.note ? t(String(raw.note)) : '',
             hints: [t(RULE_TEXT)], locale: opts.locale || 'en' }
}

// ---- ПЛАНИ: cell_passport.plan {month, boundary, series: [{key, kind: bar|line, title, color, width, dash, opacity, points}], level_title} ----
export function plansChart_visible(raw) {
    return !!(raw && typeof raw === 'object' && raw.state === 'ok' && Array.isArray(raw.series) && raw.series.some(s => s && Array.isArray(s.points) && s.points.length))
}
export function plansChart_build(raw, t = _t, opts = {}) {
    if (!plansChart_visible(raw)) return null
    const series = raw.series.filter(s => s && Array.isArray(s.points) && s.points.length)
    const center = String(raw.month || '').slice(0, 7), boundary = String(raw.boundary || '').slice(0, 7)
    let mFrom = center || '9999-99', mTo = center || '0000-00'
    for (const s of series) for (const p of _pts(s)) { if (p.ym < mFrom) mFrom = p.ym; if (p.ym > mTo) mTo = p.ym }
    const months = seriesChart_months(mFrom, mTo)
    const rows = months.map(ym => ({ date: ym + '-01' }))
    const byYm = Object.fromEntries(rows.map(r => [r.date.slice(0, 7), r]))
    let max = 0, min = 0
    const attrs = [], legend = [], zeros = {}
    const bars = series.filter(s => s.kind === 'bar'), lines = series.filter(s => s.kind !== 'bar')
    for (const s of bars) {
        const key = 'p_' + String(s.key).replace(/[^A-Za-z0-9_]/g, '_'), opacity = Number.isFinite(Number(s.opacity)) ? Number(s.opacity) : 0.4, color = s.color || '#9e9e9e'
        for (const p of _pts(s)) if (byYm[p.ym]) { byYm[p.ym][key] = p.v; if (p.v > max) max = p.v; if (p.v < min) min = p.v }
        attrs.push(_barAttr(key, s.title, color, opacity))
        legend.push({ kind: key, title: s.title, color: _legendBar(color, opacity), bar: true, sub: '' })
    }
    lines.forEach((s, i) => {
        const key = 'p_' + String(s.key).replace(/[^A-Za-z0-9_]/g, '_'), width = Number.isFinite(Number(s.width)) && Number(s.width) > 0 ? Number(s.width) : 1.5
        const opacity = Number.isFinite(Number(s.opacity)) ? Number(s.opacity) : 1, color = s.color || '#546e7a'
        for (const p of seriesChart_fillZeros(_pts(s))) if (byYm[p.ym]) { byYm[p.ym][key] = p.v; if (p.zero) (zeros[key] || (zeros[key] = {}))[p.ym] = true; if (p.v > max) max = p.v; if (p.v < min) min = p.v }
        attrs.push(_lineAttr(key, s.title, color, opacity, width, s.dash || ''))
        legend.push({ kind: key, title: s.title, color: seriesChart_rgba(color, opacity), bar: false, width, dash: s.dash || '', sub: '' })
    })
    const range = _axisRange(max, min)
    const zones = []
    if (boundary) for (const r of rows) { const ym = r.date.slice(0, 7); if (ym <= boundary) { const z = _zoneBand(rows, ym, FACT_STYLE); if (z) zones.push(z) } }
    const cz = _zoneBand(rows, center, CENTER_STYLE); if (cz) zones.push(cz)
    const curRow = byYm[center] || {}
    const summary = legend.filter(l => curRow[l.kind] != null).slice(0, 4).map(l => l.title + ' ' + seriesChart_fmtNum(curRow[l.kind])).join(' · ')
    return { rows, attrs, zones, legend, chart: { 'axisY-max': range.max, 'axisY-min': range.min, 'axisX-mainRow-keep': center }, center, boundary, zeros,
             summary, deviation: '', note: '', hints: [t(ZERO_RULE_TEXT)], level: raw.level, levelTitle: raw.level_title, locale: opts.locale || 'en' }
}

// ---- синтетический виджет AttrChart (образец cellChart_ensure / cellChart_apply) ----
export function seriesChart_ensure(store, wid, title) {
    if (!store.WIDGETS[wid]) {
        const attr = {
            id: wid + '-attr', html_id: wid + '-flex', name: 'cellSeriesChart', attr_type: 'AttrChart', component: 'AttrChart', binding: 'doc.rows',
            freq: 'M', height: SERIES_CHART_HEIGHT, hideTitle: true, title: '',
            'legend-position': 'None', 'legend-grouped': false, 'compact-axisX': false, 'compact-axisY': true,   // compact-axisX прячет подписи оси X (AttrChart.axesCompactApply) — здесь ось месяцев штатная wijmo
            'axisX-position': 'Bottom', 'axisY-position': 'Left', 'axisY-majorGrid': true, 'axisX-sameScale': false,
            'axisX-mainRow': true, 'axisX-monthAxis': true, 'tooltip-inline': true,   // IE 2026 10 22 / ODOO-5800: ось «месяц / год» без ряда-распорки (AttrChart.monthAxis_draw, флаг fe.ux.chartMonthAxis)
            attrs: [], drawAlarmZone: [],
        }
        store.WIDGETS[wid] = {
            id: wid, workspace: 'workspace-store', page: 'page-store', widget: 'widget-cell-series-chart', widget_class: 'widget_LIST', title: title || t0('Cell chart'),
            record: { id: wid, segment: 'CELL-SERIES-CHART', version: '', doc: { rows: [] }, _doc: {}, _meta: {} },
            view: [attr], attrsResize: [], attrs_vueObj: {},
        }
    }
    return store.WIDGETS[wid]
}
export function seriesChart_apply(store, wid, chart, off) {   // chart — результат *_build; off — {binding: true} выключенных в легенде серий
    const W = seriesChart_ensure(store, wid)
    const attr = W.view[0]
    W.record.doc.rows = (chart && chart.rows || []).map(r => ({ ...r }))
    attr.attrs = (chart && chart.attrs || []).filter(a => !(off && off[a.binding])).map(a => ({ ...a, cssStyleChart: { ...a.cssStyleChart } }))
    attr.drawAlarmZone = (chart && chart.zones || []).map(z => ({ ...z }))
    for (const k of ['axisY-max', 'axisY-min', 'axisX-mainRow-keep', 'chart_stack2']) { if (chart && chart.chart && chart.chart[k] !== undefined) attr[k] = chart.chart[k]; else delete attr[k] }
    return W
}
export function seriesChart_legendValue(chart, lg, hoverI) {   // значение строки легенды: в колонке под курсором, иначе в месяце ячейки
    if (!chart || !lg) return ''
    const rows = chart.rows || []
    const row = (hoverI != null && hoverI >= 0 && rows[hoverI]) ? rows[hoverI] : rows.find(r => r.date.slice(0, 7) === chart.center)
    const v = row ? row[lg.kind] : null
    if (v === null || v === undefined) return ''
    const zero = chart.zeros && chart.zeros[lg.kind] && row && chart.zeros[lg.kind][row.date.slice(0, 7)]
    return seriesChart_fmtNum(v) + (zero ? ' (' + t0('no plan') + ')' : '')
}
export function seriesChart_chipRows(chip) {   // чипс ↗: объект / БЮ / страна / субъект ячейки; мера и месяц — не селекторы списка (период = весь горизонт ПМ)
    return (Array.isArray(chip) ? chip : []).filter(c => c && c.field && !['month', 'measure'].includes(String(c.field).toLowerCase()))
}
export function plansWidget_emptyText(state, t = (s) => s) {
    const st = String(state || '')
    if (!st) return t('Computing the plans…')
    if (st === 'no object') return t('Open the widget from the PLANS block of the cell form: the chip carries the object (brand / BU), country, page segment and month')
    if (st === 'no segment') return t('No plan page segment in the chip — open the widget from the PLANS block of a plan page')
    if (st === 'no version') return t('No version of the table — open the widget on a page with a version')
    if (st === 'off') return t('The plans widget is switched off (not-plans_widget)')
    if (st !== 'ok') return t('No plans: {state}', { state: st })
    return t('No plan series for this context')
}

export default { versionsChart_build, plansChart_build, seriesChart_ensure, seriesChart_apply, seriesChart_legendValue, seriesChart_chipRows, seriesChart_fillZeros, seriesChart_fmtNum, seriesChart_fmtPct, versionsChart_deviationText }
